<template>
  <div id="app">
    <!-- 当页面没有表格的时候，隐藏的loading的div -->
    <div class="hideloading" style="opacity:0"></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue